import { render, staticRenderFns } from "./ServiceMenuItem.vue?vue&type=template&id=0eb663ce&scoped=true&"
import script from "./ServiceMenuItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceMenuItem.vue?vue&type=style&index=0&id=0eb663ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb663ce",
  null
  
)

export default component.exports